/* amigo-invisible.js - Versión Marketing (Link a Superchula) */
(function () {
  'use strict';

  function parseParticipants(text) {
    if (!text) return [];
    const cleanText = text.replace(/\\n/g, '\n'); 
    return cleanText.split(/\r?\n/).map(l => l.trim()).filter(Boolean).map(n => ({ name: n }));
  }

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function createPairs(participants) {
    if (participants.length < 2) return [];
    const maxAttempts = 200; let attempts = 0;
    const idx = participants.map((_, i) => i);
    while (attempts < maxAttempts) {
      attempts++;
      const shuffled = shuffle(idx.slice());
      let ok = true;
      for (let i = 0; i < idx.length; i++) {
        if (participants[idx[i]].name === participants[shuffled[i]].name) { ok = false; break; }
      }
      if (ok) return idx.map((giverIndex, i) => ({ giver: participants[giverIndex], receiver: participants[shuffled[i]] }));
    }
    const rotated = participants.map((p, i) => participants[(i + 1) % participants.length]);
    return participants.map((p, i) => ({ giver: p, receiver: rotated[i] }));
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function renderPairsToContainer(container, pairs) {
    const area = container.querySelector('.ai-results');
    const blurCheckbox = container.querySelector('#ai-blur-check');
    const isBlurred = blurCheckbox ? blurCheckbox.checked : false;

    area.innerHTML = '';
    
    if (!pairs || pairs.length === 0) {
      return;
    }

    pairs.forEach((pair, i) => {
      // --- CONFIGURACIÓN DEL MENSAJE DE WHATSAPP ---
      // %0A crea un salto de línea.
      // Hemos añadido la frase promocional y el enlace a tu web.
      const waText = `¡Hola ${pair.giver.name}! 👋%0A%0ATe ha tocado ser el Amigo Invisible de: *${pair.receiver.name}* 🎁.%0A%0A🤫 ¡No rompas la sorpresa!%0A%0A💡 ¿Buscas ideas originales?%0AEncuentra el regalo perfecto aquí: https://www.superchula.com`;
      
      const waLink = `https://wa.me/?text=${waText}`;

      const div = document.createElement('div');
      div.className = 'ai-pair';
      
      div.innerHTML = `
        <div class="ai-names-block">
          <div class="ai-name">${escapeHtml(pair.giver.name)}</div>
          <div class="ai-small">regala a ➔</div>
          <div class="ai-name ai-target-name ${isBlurred ? 'blurred' : ''}" title="Clic para revelar/ocultar">${escapeHtml(pair.receiver.name)}</div>
        </div>
        
        <a href="${waLink}" target="_blank" class="ai-wa-btn" aria-label="Enviar a ${escapeHtml(pair.giver.name)}">
          <span>WhatsApp</span>
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-top:-2px"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326z"/></svg>
        </a>
      `;
      
      area.appendChild(div);
      setTimeout(() => div.classList.add('show'), 50 * i);

      const targetSpan = div.querySelector('.ai-target-name');
      targetSpan.addEventListener('click', () => targetSpan.classList.toggle('blurred'));
    });
  }

  function initWidget(container) {
    const textarea = container.querySelector('.ai-participants');
    if (textarea && typeof textarea.value === 'string') textarea.value = textarea.value.replace(/\\r?\\n/g, '\n');

    const btnGen = container.querySelector('.ai-generate');
    const btnSample = container.querySelector('.ai-sample');
    const btnClear = container.querySelector('.ai-clear');
    const blurCheck = container.querySelector('#ai-blur-check');

    blurCheck && blurCheck.addEventListener('change', () => {
       if (container.__ai_pairs) renderPairsToContainer(container, container.__ai_pairs);
    });

    if (!btnGen) return;

    btnGen.addEventListener('click', function () {
      const participants = parseParticipants(textarea.value);
      if (participants.length < 2) { alert('Introduce al menos 2 nombres (uno por línea).'); return; }
      
      btnGen.style.transform = "scale(0.95)";
      setTimeout(() => btnGen.style.transform = "", 150);

      const pairs = createPairs(participants);
      container.__ai_pairs = pairs;
      renderPairsToContainer(container, pairs);
    });

    btnSample && btnSample.addEventListener('click', () => {
      textarea.value = ['Ana', 'Pablo', 'Lucía', 'Marcos', 'Elena'].join('\n');
    });

    btnClear && btnClear.addEventListener('click', () => {
      textarea.value = '';
      const area = container.querySelector('.ai-results');
      if(area) area.innerHTML = '';
      container.__ai_pairs = [];
    });
  }

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(() => document.querySelectorAll('.ai-widget').forEach(initWidget));

})();